import request from "../utils/request";

export function listTreeStatistic(params) {
  //
  return request({
    url: "/api/orgs/forrest/trees-value-counts/",
    method: "get",
    params
  });
}
export function listForestMap(params) {
  // возвращает список заповедников для карты (урезанный объект )
  return request({
    url: "/api/orgs/forrest/",
    method: "get",
    params
  });
}
export function detailForestMap(params) {
  // возвращает определенный заповедник
  return request({
    url: `/api/orgs/forrest/${params}/`,
    method: "get"
    // params
  });
}


export function listAnimalTable(params) {
  // возвращает животных для таблицы в dasboarde
  return request({
    url: `/api/orgs/animal_table/`,
    method: "get",
    params
  });
}
export function listAnimalStatistic(params) {
  // возвращает статистику  животных
  return request({
    url: `/api/orgs/animal_types_count/`,
    method: "get",
    params
  });
}
export function listAnimalsTypes(params) {
  // возвращает список типов животных  для карты
  return request({
    url: "/api/orgs/animal_types/",
    method: "get",
    params
  });
}
export function listAnimalsMap(params) {
  // возвращает список животных  для карты (урезанный объект )
  return request({
    url: "/api/orgs/forrest/animals/",
    method: "get",
    params
  });
}
export function detailAnimalsMap(params) {
  // возвращает определенное животное 
  return request({
    url: `/api/orgs/forrest/animals/${params}/`,
    method: "get"
    // params
  });
}




